export const TemplateViewApiRoutes = {
  my: 'me',
  all: 'all',
  team: 'all_but_mine'
};

export const TEMPLATE_VIEW_TYPES = {
  MY_TEMPLATES: 'myTemplates',
  ORGANIZATION_TEMPLATES: 'organizationTemplates',
  AVOMA_TEMPLATES: 'avomaTemplates',
  ALL_TEMPLATES: 'allTemplates',
  EMAIL_TEMPLATES: 'emailTemplates'
};

export const TEMPLATE_VIEW_TYPES_MAP = {
  [TEMPLATE_VIEW_TYPES.ALL_TEMPLATES]: {
    name: 'All Templates',
    description:
      'Discover templates organized by collections and use cases. Find the template that fits your needs.'
  },
  [TEMPLATE_VIEW_TYPES.MY_TEMPLATES]: {
    name: 'My Templates',
    description: "Templates you've created and customized for your meetings."
  },
  [TEMPLATE_VIEW_TYPES.ORGANIZATION_TEMPLATES]: {
    name: 'Organization Templates',
    description: 'Templates created by the organization.'
  },
  [TEMPLATE_VIEW_TYPES.EMAIL_TEMPLATES]: {
    name: 'Email Templates',
    description: 'Manage reusable AI-powered email templates.'
  }
};

export const NEW_TEMPLATE_UUID = 'create_new';

export const ALL_COLLECTION_STYLES = [
  'bg-blue-50 border-blue-100',
  'bg-green-50 border-green-100',
  'bg-purple-50 border-purple-100',
  'bg-orange-50 border-orange-100',
  'bg-pink-50 border-pink-100',
  'bg-orange-50 border-orange-100'
];

export const AVOMA_DEFAULT_TEMPLATE = {
  name: 'Avoma Default',
  user: {
    id: 0,
    email: 'ai@avoma.com',
    firstName: '',
    lastName: '',
    profilePic: null,
    position: undefined,
    isActive: true,
    jobFunction: '',
    upn: null
  },
  modifiedBy: {
    id: 0,
    email: 'ai@avoma.com',
    firstName: 'Avoma',
    lastName: '',
    profilePic: null,
    position: undefined,
    isActive: true,
    jobFunction: '',
    upn: null
  },
  description: 'Avoma AI will auto-detect topics and generate notes',
  text: '',
  textSlate: '',
  uuid: 'avoma-default',
  meetingTypes: [],
  isDefault: true,
  isDefaultForUser: false,
  created: '',
  modified: '',
  privacy: 'organization' as const
};

export const ACTION_ITEM_SLATE_ELEMENT = [
  {
    type: 'header-2',
    data: {
      highlight_notes_title: true,
      block_key: 'highlight_category_key_takeaways'
    },
    children: [
      {
        text: 'Key Takeaways'
      }
    ]
  },
  {
    type: 'header-2',
    data: {
      highlight_notes_title: true,
      block_key: 'highlight_category_action_item'
    },
    children: [
      {
        text: 'Action Items'
      }
    ]
  },
  {
    type: 'header-2',
    data: {
      highlight_notes_title: true,
      block_key: 'highlight_category_next_meeting_date'
    },
    children: [
      {
        text: 'Follow-up Meeting'
      }
    ]
  }
];

export const TEMPLATE_ERRORS = {
  NOT_FOUND: 'Not found.'
};
